<template>
  <div>
    <LoadingState
      v-if="loading"
      :loading="loading"
    />
    <v-container
      v-else
      grid-list-xl
      fluid
    >
      <v-layout
        row
        wrap
        class="mt-3"
      >
        <!-- Toolbar Navigation -->
        <v-toolbar
          flat
          color="transparent"
          class="mb-4 mt-4"
          height="20px"
        >
          <v-btn
            icon
            class="text--secondary"
            @click="goBack"
          >
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <span class="text-capitalize subheading text--secondary">
            {{ $t('Settings') }}
          </span>
        </v-toolbar>
        <v-flex
          xs12
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              md4
              offset-md1
            >
              <h3 class="title font-weight-regular pt-3">
                {{ $t('Customers Settings') }}
              </h3>
              <span
                class="caption"
              >
                {{ $t('Configure customer general settings') }}
              </span>
            </v-flex>
            <v-flex
              xs12
              md6
            >
              <v-card
                flat
                class="pa-3"
              >
                <template v-if="generalSettings">
                  <v-switch
                    v-model="generalSettings.require_dob"
                    :label="$t('Require Customer Date of Birth')"
                    outline
                  />
                </template>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
        class="mt-3"
      >
        <v-flex
          xs12
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              md4
              offset-md1
            >
              <h3 class="title font-weight-regular pt-3">
                {{ $t('Customers Groups') }}
              </h3>
              <span
                class="caption"
              >
                {{ $t('Configure customer groups') }}
              </span>
            </v-flex>
            <v-flex
              xs12
              md6
            >
              <v-card
                flat
                class="pa-3"
              >
                <template v-if="customerSettings">
                  <v-autocomplete
                    v-model="customerSettings.customer.default_group"
                    :items="groups"
                    :label="$t('Customer Default Group')"
                    item-text="name"
                    item-value="code"
                    outline
                  />
                  <v-autocomplete
                    v-model="customerSettings.guest.default_group"
                    :items="groups"
                    :label="$t('Guest Default Group')"
                    item-text="name"
                    item-value="code"
                    outline
                  />
                </template>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-layout
      v-if="!loading"
      row
      wrap
      color="transparent"
    >
      <v-flex
        xs12
        ma-3
      >
        <v-divider mb-3/>
        <v-btn
          large
          class="primary right mt-3"
          @click="save()"
        >
          {{ $t('Save') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import LoadingState from '@/components/LoadingState'

export default {
  name: 'CustomerSettingsCustomers',
  components: {
    LoadingState
  },

  data () {
    return {
      loading: false,
      customerSettings: null,
      generalSettings: null,
      groups: []
    }
  },

  async mounted () {
    this.loading = true
    this.customerSettings = await this.$http.make('settings').find('customers')
    this.generalSettings = await this.$http.make('settings').find('general/customer')
    this.groups = await this.$http.make('customer:group').get()
    this.loading = false
  },

  methods: {
    goBack () {
      this.$router.push({ name: 'settings' })
    },

    async save () {
      try {
        await this.saveCustomerSettings()
        await this.saveGeneralSettings()
        this.$toast(this.$t('Customer settings saved'))
      } catch (e) {
        this.$toast.error(this.$t(e.message))
      }
    },

    async saveCustomerSettings () {
      let settings = this.$http.make('settings', { data: {
        customer: this.customerSettings.customer,
        guest: this.customerSettings.guest
      } })
      settings.code_url = 'customers'

      await settings.save()
    },

    async saveGeneralSettings () {
      let settings = this.$http.make('settings', { data: {
        require_dob: this.generalSettings.require_dob
      } })
      settings.code_url = 'general/customer'

      await settings.save()
    }
  }
}
</script>
